import * as actionTypes from "../actionTypes.js";

const initialState = {
  activitiesList: null,

};

const businessFusionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ACTIVITIES_BIZ_FUSION:
      return { ...state, activitiesList: action.payload };
      

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessFusionReducer;